import { ComponentProps } from 'react'

import DropZone from 'modules/core/components/DropZone'

interface Props extends Omit<ComponentProps<typeof DropZone>, 'accept'> {}

const acceptedDocuments = {
  'application/vnd.ms-excel': [],
  'text/csv': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
}

const DropSpreadsheetZone = (props: Props) => {
  return <DropZone {...props} accept={acceptedDocuments} />
}

export default DropSpreadsheetZone
